import { handleActions } from 'redux-actions';
import update from 'immutability-helper';

import {
  CONNECT_WEBSOCKET,
  DISCONNECT_WEBSOCKET,
} from '../constants/ActionTypes';

const initialState = {
  connected: false,
};

const websocket = handleActions({
  [CONNECT_WEBSOCKET]: state => update(state, { connected: { $set: true } }),
  [DISCONNECT_WEBSOCKET]: state => update(state, { connected: { $set: false } }),
}, initialState);

export default websocket;



// WEBPACK FOOTER //
// ./src/reducers/websocket.js